import React from 'react';
import { Heading, PropertyGroup } from '../../components';

import css from './ListingPage.module.css';
import classNames from 'classnames';

const SectionMultiEnumMaybe = props => {
  const { heading, options, selectedOptions, showUnselectedOptions = true } = props;
  const hasContent = showUnselectedOptions || selectedOptions?.length > 0;
  if (!heading || !options || !hasContent) {
    return null;
  }
  const idSlug = heading.toLowerCase().replace(/ /g, '_');

  return (
    <section className={css.sectionMultiEnum}>
      <Heading as="h2" rootClassName={classNames(css.sectionHeading,css.genricHeaidng)}>
        {heading}
      </Heading>
      <PropertyGroup
        id={`ListingPage.${idSlug}`}
        ariaLabel={heading}
        options={options}
        selectedOptions={selectedOptions}
        twoColumns={options.length > 5}
        showUnselectedOptions={showUnselectedOptions}
      />
    </section>
  );
};

export default SectionMultiEnumMaybe;
